import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { Button } from '@/components/ui/Button';
import { useAuthContext } from '../providers/AuthProvider';
import { forgotPassword } from '../api/auth.api';

interface PasswordChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PasswordChangeModal: React.FC<PasswordChangeModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { userInfo } = useAuthContext();

  const handleSubmit = async () => {
    if (!userInfo?.username) return;

    setIsLoading(true);
    try {
      await forgotPassword({ email: userInfo.username });
      toast.success(
        'Un lien de réinitialisation a été envoyé à votre adresse email'
      );
      onClose();
    } catch (error) {
      toast.error("Erreur lors de l'envoi du lien de réinitialisation");
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[51] flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-neutralBG-dark">
        <h2 className="mb-4 text-xl font-semibold text-neutralText dark:text-neutralText-dark">
          Changement de mot de passe requis
        </h2>
        <p className="mb-4 text-sm text-neutralText dark:text-neutralText-dark">
          Votre mot de passe a expiré. Cliquez sur le bouton ci-dessous pour
          recevoir un lien de réinitialisation par email.
        </p>
        <div className="flex justify-end gap-2">
          <Button
            type="button"
            variant="text"
            onClick={onClose}
            disabled={isLoading}
          >
            Annuler
          </Button>
          <Button
            type="button"
            onClick={handleSubmit}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Envoyer le lien
          </Button>
        </div>
      </div>
    </div>
  );
};
